module.exports = __webpack_public_path__ + "img/bg1@3x.3e417a89.png";